import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Home from './pages/Home';
import Report from './pages/Report';
import Sessions from './pages/Sessions';
import ScanLoading from './pages/ScanLoading';
import NotFound from './pages/NotFound';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import Accessibility from './pages/Accessibility';
import Login from './pages/Login';
import Register from './pages/Register';
import Footer from './components/Footer';
import './App.css';

function Nav() {
  const location = useLocation();
  const { user, logout } = useAuth();
  const isHome = location.pathname === '/';
  const isLoading = location.pathname.startsWith('/loading');
  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';

  // Only hide nav on loading pages (keep it on home with overlay style)
  if (isLoading) return null;

  return (
    <nav className={`nav ${isHome ? 'nav-overlay' : ''} ${isAuthPage ? 'nav-minimal' : ''}`} aria-label="Main navigation">
      <Link to="/" className="nav-logo">
        <img src="/assets/logo.png" alt="autopsyURL" className="nav-logo-img" />
      </Link>
      <div className="nav-links">
        {user && !isAuthPage && (
          <Link to="/sessions" className={location.pathname === '/sessions' ? 'active' : ''}>
            Sessions
          </Link>
        )}
        {user ? (
          <>
            <span className="nav-user">{user.name || user.email}</span>
            <button onClick={logout} className="nav-logout">Sign Out</button>
          </>
        ) : (
          <>
            <Link to="/login" className="nav-link">Sign In</Link>
            <Link to="/register" className="nav-register">Get Started</Link>
          </>
        )}
      </div>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Nav />
      <main id="main-content" className="main" role="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/loading/:scanId" element={<ScanLoading />} />
          <Route path="/report/:scanId" element={<Report />} />
          <Route path="/scan/:scanId" element={<Report />} />
          <Route path="/sessions" element={<Sessions />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
